import React from "react";
import {Trans} from "react-i18next";
import MainLayout from "../../../common/MainLayout/components/mainLayout";
import ProfileTabMenu from "../../components/profileTabMenu";
import ContentLayout from "../../../common/ContentLayout/components/contentLayout";
import AccountPaymentMethodsForm from "../components";

const AccountPaymentMethods = () => {
  return (
    <MainLayout
      backLink="../profile"
      statusBar={<ProfileTabMenu selectedTab={3} />}
      pageTitle="Payment Methods"
    >
      <ContentLayout
        title={
          <Trans i18nKey={"profile.tabs.paymentMethods"}>Payment methods</Trans>
        }
        backLink="../profile"
        content={<AccountPaymentMethodsForm />}
        containerSx={{mb: "24px"}}
      />
    </MainLayout>
  );
};

export default AccountPaymentMethods;
